import React from 'react';

const SvgCircle = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" {...props}>
    <circle stroke="#FFC543" strokeWidth={2} cx={20} cy={20} r={19} fill="none" />
  </svg>
);

export default SvgCircle;
